import { useMutation, useQueryClient } from '@tanstack/react-query';
import { UpdateNoteReceivableInput, useGetNoteReceivablesQuery } from '../generated/graphql';
import {
  clientCloseNoteReceivable,
  CloseNoteReceivableInput,
  clientUpdateNoteReceivable,
  useGraphqlClient,
} from '../graphql';
import { noteReceivableKeys } from './queryKeys';
import { closedAccountsQueryKey, ttDetailsKeys } from '../TtDetails';

export const useUpdateNoteReceivable = () => {
  const queryClient = useQueryClient();
  const gqlClient = useGraphqlClient();

  const updateNoteReceivable = useMutation({
    mutationFn: (input: UpdateNoteReceivableInput) => {
      return clientUpdateNoteReceivable(gqlClient, input);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(noteReceivableKeys.base);
    },
  });

  return { updateNoteReceivable };
};

export const useCloseNoteReceivable = () => {
  const queryClient = useQueryClient();
  const gqlClient = useGraphqlClient();

  const closeNoteReceivable = useMutation({
    mutationFn: (input: CloseNoteReceivableInput) => {
      return clientCloseNoteReceivable(gqlClient, input);
    },
    onSuccess: async (_data, variables) => {
      queryClient.invalidateQueries(noteReceivableKeys.base);
      queryClient.invalidateQueries(closedAccountsQueryKey(variables.householdID, 'NoteReceivable'));
      // useTotalAccountsDecay reads note receivables via the generated query, so
      // invalidate its key too or the "out-dated" total stays stale after a close.
      queryClient.invalidateQueries(useGetNoteReceivablesQuery.getKey({ householdID: variables.householdID }));
      await queryClient.invalidateQueries(ttDetailsKeys.base);
    },
  });

  return { closeNoteReceivable };
};
